import React from 'react';
import { Dumbbell, Shield, Target, Cross } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
const features = [{
  icon: Dumbbell,
  title: 'STRENGTH',
  desc: 'Physical and mental fortitude to push through barriers.'
}, {
  icon: Shield,
  title: 'DISCIPLINE',
  desc: "Doing what needs to be done, especially when it's hard."
}, {
  icon: Target,
  title: 'CONSISTENCY',
  desc: 'Showing up every single day. The compound effect of effort.'
}, {
  icon: Cross,
  title: 'FAITH',
  desc: 'Grounded in purpose, guided by unwavering belief.'
}];
export function RhinoMindSection() {
  return <section id="rhino-mind" className="py-24 bg-rhino-black relative overflow-hidden" data-id="element-129">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-rhino-charcoal/50 to-transparent pointer-events-none" data-id="element-130"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-131">
        <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-132">
          <FadeIn data-id="element-133">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-white tracking-wide mb-8" data-id="element-134">
              WHAT IS <span className="text-rhino-gold" data-id="element-135">RHINO MIND?</span>
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-136">
            <div className="bg-rhino-charcoal p-8 md:p-12 rounded-sm border-l-4 border-rhino-gold shadow-2xl" data-id="element-137">
              <p className="text-lg md:text-xl text-gray-300 leading-relaxed text-left" data-id="element-138">
                "The Rhino Mind is more than a self-help book. It is a
                faith-driven mindset that refuses to live small, refuses to
                stall in life. It is a strategic playbook for anyone tired of
                settling for less than their God-given potential. It is for
                those ready to charge forward with strength, discipline, and
                decisiveness. Learn how to cultivate the mindset required for
                growth and the relentless charge required for victory."
              </p>
            </div>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-139">
          {features.map((feature, index) => <FadeIn key={index} delay={0.3 + index * 0.1} data-id="element-140">
              <motion.div whileHover={{
            y: -10
          }} className="bg-rhino-charcoal p-8 rounded-sm border border-rhino-grey hover:border-rhino-gold/50 transition-colors h-full group" data-id="element-141">
                <div className="w-14 h-14 bg-rhino-black rounded-sm flex items-center justify-center mb-6 group-hover:bg-rhino-gold/10 transition-colors border border-rhino-grey group-hover:border-rhino-gold/30" data-id="element-142">
                  <feature.icon className="text-rhino-gold w-7 h-7" data-id="element-143" />
                </div>
                <h3 className="text-xl font-heading font-bold text-white mb-3 tracking-wide" data-id="element-144">
                  {feature.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-145">
                  {feature.desc}
                </p>
              </motion.div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}